import Buttons from './Buttons';
import RadiosTable from './RadiosTable';

export {
  Buttons,
  RadiosTable,
}


// WEBPACK FOOTER //
// ./src/views/MergeLeads/components/index.js